import { render, staticRenderFns } from "./ButtonGradient.vue?vue&type=template&id=84c37338&scoped=true"
import script from "./ButtonGradient.vue?vue&type=script&lang=js"
export * from "./ButtonGradient.vue?vue&type=script&lang=js"
import style0 from "./ButtonGradient.vue?vue&type=style&index=0&id=84c37338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c37338",
  null
  
)

export default component.exports